module.exports = __webpack_public_path__ + "img/EARRINGS PURPLE.d532e13.svg";